import React, { useState, useMemo, useCallback } from "react";

import { Button, Spinner } from "reactstrap";

import WorkflowRequirementStageToStageAttributes from "../../workflow/requirement_stage/to_stage_attributes";
import WorkflowRequirementStageAttributes from "../../workflow/requirement_stage/attributes";

import WorkflowRequirementStageFormContext from "../../workflow/requirement_stage/context/form";

import {
  nextStages as nextStagesHelper,
  returnStages as returnStagesHelper,
  isInputStage as isInputStageHelper,
  isDefaultStage as isDefaultStageHelper,
  isOutputStage as isOutputStageHelper,
  isShortlistStage as isShortlistStageHelper
} from "./helper";

import axios from "axios";

const optionsForModule = (tenant, requirement_hashid, requirement_stage_hashid, current_entity_type_hashid) => {
  return {
    karinLaw: {
      defaultRequestParams: {
        id: requirement_stage_hashid
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_hashid ? Routes.karin_law_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid ? Routes.karin_law_workflow_requirement_stage_path : undefined
      }
    },
    portalKarinLaw: {
      defaultRequestParams: {
        id: requirement_stage_hashid,
        tenant: tenant
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid,
        tenant: tenant
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_stage_hashid && tenant ? Routes.portal_karin_law_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid && tenant ? Routes.portal_karin_law_workflow_requirement_stage_path : undefined
      }
    },
    abstract: {
      defaultRequestParams: {
        id: requirement_stage_hashid,
        current_entity_type_id: current_entity_type_hashid
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid,
        current_entity_type_id: current_entity_type_hashid
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_hashid && current_entity_type_hashid ? Routes.abstract_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid && current_entity_type_hashid ? Routes.abstract_workflow_requirement_stage_path : undefined
      }
    },
    portalAbstract: {
      defaultRequestParams: {
        id: requirement_stage_hashid,
        tenant: tenant
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid,
        tenant: tenant
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_hashid && tenant ? Routes.portal_abstract_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid && tenant ? Routes.portal_abstract_workflow_requirement_stage_path : undefined
      }
    },
    laboral: {
      defaultRequestParams: {
        id: requirement_stage_hashid
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_hashid ? Routes.laboral_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid ? Routes.laboral_workflow_requirement_stage_path : undefined
      }
    },
    portalLaboral: {
      defaultRequestParams: {
        id: requirement_stage_hashid,
        tenant: tenant
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid,
        tenant: tenant
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_hashid && tenant ? Routes.portal_laboral_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid && tenant ? Routes.portal_laboral_workflow_requirement_stage_path : undefined
      }
    },
    economicCrime: {
      defaultRequestParams: {
        id: requirement_stage_hashid,
      },
      defaultRequestRequirementParams: {
        id: requirement_hashid
      },
      routes: {
        showRequirementPath: requirement_stage_hashid && requirement_hashid ? Routes.economic_crime_workflow_requirement_path : undefined,
        updateRequirementStagePath: requirement_stage_hashid ? Routes.economic_crime_workflow_requirement_stage_path : undefined
      }
    },
  };
};

const requirementStageFormData = (requirementStage, formName) => {
  let _formData = new FormData();

  if (requirementStage.observations != null && requirementStage.observations !== "") {
    _formData.append(`${formName}[observations]`, requirementStage.observations);
  }

  if (requirementStage.aasm_state_event != null && requirementStage.aasm_state_event !== "") {
    _formData.append(`${formName}[aasm_state_event]`, requirementStage.aasm_state_event);
  }

  if (Array.isArray(requirementStage.to_stage_authorized_emails) && requirementStage.to_stage_authorized_emails.length > 0) {
    _.each(requirementStage.to_stage_authorized_emails, email => {
      if (email != null && email !== "") {
        _formData.append(`${formName}[to_stage_authorized_emails][]`, email);
      }
    });
  }

  if (requirementStage.aasm_state_event === "to_proceeded" || requirementStage.aasm_state_event === "to_returned") {
    if (requirementStage.to_stage_id != null && requirementStage.to_stage_id !== "") {
      _formData.append(`${formName}[to_stage_id]`, requirementStage.to_stage_id);
    }
  } else {
    _formData.append(`${formName}[to_stage_id]`, "");
  }

 _formData.append(`${formName}[output_form_attributes][id]`, requirementStage?.output_form?.id || '');

  const outputFieldItems = requirementStage?.output_form?.field_items || [];

  const outputFieldItemsFormName = `${formName}[output_form_attributes][field_items_attributes]`
  _.each(outputFieldItems, (fieldItem, index) => {

    _formData.append(`${outputFieldItemsFormName}[${index}][id]`, fieldItem?.id || '');
    _formData.append(`${outputFieldItemsFormName}[${index}][value]`, fieldItem?.value || '');
  })

  const outputFileItems = requirementStage?.output_form?.file_items || [];
  const outputFileItemsFormName = `${formName}[output_form_attributes][file_items_attributes]`;

  _.each(outputFileItems, (fileItem, index) => {
    _formData.append(`${outputFileItemsFormName}[${index}][id]`, fileItem?.id || '');
    _formData.append(`${outputFileItemsFormName}[${index}][touched_at]`, _.random(0, 100000));

    if (fileItem?.file) {
      _formData.append(`${outputFileItemsFormName}[${index}][file]`, fileItem?.file || '');
    } else if (fileItem?.reference_to) {
      _formData.append(`${outputFileItemsFormName}[${index}][reference_to]`, fileItem?.reference_to || '');
    }
  })

  return _formData;
};

const WorkflowRequirementStageForm = (props) => {
  const {
    requirementStage: initialRequirementStage,
    policies,
    configuration,
    showNextStageAttributes = false,
    currentEntityType,
    onSuccessSubmit: onSuccessSubmitFromProps
  } = props;

  const [requirementStage, setRequirementStage] = useState(initialRequirementStage);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const requirementStageType = useMemo(() => {
    if (requirementStage?.module_type === "KarinLaw::Workflow::RequirementStage") {
      return "karinLaw";
    } else if (requirementStage?.module_type === "EconomicCrime::Workflow::RequirementStage") {
      return "economicCrime";
    }
  }, [requirementStage]);

  const nextStages = useMemo(() => nextStagesHelper(requirementStage), [requirementStage?.next_stages]);
  const returnStages = useMemo(() => returnStagesHelper(requirementStage), [requirementStage?.return_stages]);
  const isInputStage = useMemo(() => isInputStageHelper(requirementStage), [requirementStage?.node_type]);
  const isDefaultStage = useMemo(() => isDefaultStageHelper(requirementStage), [requirementStage?.node_type]);
  const isOutputStage = useMemo(() => isOutputStageHelper(requirementStage), [requirementStage?.node_type]);
  const isShortlistStage = useMemo(() => isShortlistStageHelper(requirementStage), [requirementStage?.node_type]);

  const currentOptionModule = useMemo(() => {
    const moduleContextMap = {
      'Abstract::Workflow::RequirementStage': {
        portal: 'portalAbstract',
        default: 'abstract'
      },
      'KarinLaw::Workflow::RequirementStage': {
        portal: 'portalKarinLaw',
        default: 'karinLaw'
      },
      'EconomicCrime::Workflow::RequirementStage': {
        default: 'economicCrime'
      },
      'Laboral::Workflow::RequirementStage': {
        portal: 'portalLaboral',
        default: 'laboral'
      }
    };

    const modType = requirementStage?.module_type;
    const ctx = configuration?.context;
    const opts = optionsForModule(configuration?.tenant, requirementStage.requirement.hashid, requirementStage.hashid, currentEntityType?.id);

    if (!modType) {
      console.warn('requirementStage.module_type is undefined');
      return {};
    }

    const contextMapping = moduleContextMap[modType];
    if (!contextMapping) {
      console.warn(`No mapping found for module_type: ${modType}`);
      return {};
    }

    const key = ctx === 'portal' && contextMapping.portal ? contextMapping.portal : contextMapping.default;

    if (!key) {
      console.warn(`No option found for context: ${ctx} under module_type: ${modType}`);
      return {};
    }

    return opts[key] || {};
  }, []);

  const {
    defaultRequestParams = {},
    defaultRequestRequirementParams = {},
    routes = {}
  } = currentOptionModule;

  const onChange = useCallback(
    (event, key) => {
      const value = event.target.value;
      setRequirementStage(prev => ({ ...prev, [key]: value }));
    },
    []
  );

  const onSuccessSubmit = useCallback(() => {
    if (typeof onSuccessSubmitFromProps === 'function') {
      onSuccessSubmitFromProps(routes, defaultRequestRequirementParams);
    } else if (routes.showRequirementPath && defaultRequestRequirementParams) {
      window.location = routes.showRequirementPath({ ...defaultRequestRequirementParams, _options: true });
    } else {
      window.location.reload();
    }
  }, [onSuccessSubmitFromProps, routes, defaultRequestRequirementParams]);

  const submit = useCallback(() => {
    if (loadingSubmit) return;
    setLoadingSubmit(true);
    const formData = requirementStageFormData(requirementStage, "workflow_requirement_stage");

    const requestParams = { ...defaultRequestParams, id: requirementStage.hashid };

    axios({
      method: "put",
      url: routes.updateRequirementStagePath && routes.updateRequirementStagePath({ ...requestParams, format: "json", _options: true }),
      data: formData,
      headers: {
        "X-CSRF-TOKEN": window.compliance.token
      }
    })
      .then(response => {
        if (response.status === 200) {
          onSuccessSubmit();
        } else {
          swalToastBootstrap.fire({
            icon: "error",
            title: I18n.t("errors.unprocessable_content")
          });
        }
        setLoadingSubmit(false);
      })
      .catch((e) => {
        console.log("Error: ", e);
        swalToastBootstrap.fire({
          icon: "error",
          title: I18n.t("errors.unprocessable_content")
        });
        setLoadingSubmit(false);
      });
  }, [requirementStage, defaultRequestParams, routes.updateRequirementStagePath, onSuccessSubmit, loadingSubmit]);

  const showNextStageSection = useMemo(() => {
    if (!showNextStageAttributes) return null;
    return (
      <WorkflowRequirementStageToStageAttributes
        requirementStage={requirementStage}
        configuration={{ formName: "workflow_requirement_stage" }}
      />
    );
  }, [showNextStageAttributes, requirementStage]);

  const showWorkflowRequirementStageAttributes = useMemo(() => {
    if (
      requirementStage.output_form.field_items.length === 0 &&
      requirementStage.output_form.file_items.length === 0 &&
      !(requirementStage.aasm_state_event === "to_rejected" || requirementStage.aasm_state_event === "to_returned")
    ) {
      return (
        <div className="alert alert-primary text-center" role="alert">
          <i className="fas fa-info-circle mr-2" aria-hidden="true" title="Información"></i>
          Sin información de salida
        </div>
      );
    } else {
      return (
        <WorkflowRequirementStageAttributes
          requirementStage={requirementStage}
          configuration={{ defaultRequestParams, formName: "workflow_requirement_stage" }}
          callbacks={{ onChangeRequirementStage: onChange }}
        />
      );
    }
  }, [requirementStage, defaultRequestParams, onChange]);

  if (!policies?.canEdit) {
    return showWorkflowRequirementStageAttributes;
  }

  return (
    <WorkflowRequirementStageFormContext.Provider
      value={{
        requirementStageType,
        data: {
          nextStages,
          returnStages
        },
        helpers: {
          isInputStage,
          isDefaultStage,
          isOutputStage,
          isShortlistStage
        },
        callbacks: { onChangeRequirementStage: onChange }
      }}
    >
      <div className="row">
        <div className="col-12">{showNextStageSection}</div>
      </div>

      {showWorkflowRequirementStageAttributes}

      <div className="d-flex justify-content-end mt-3">
        <Button color="success" onClick={submit} disabled={loadingSubmit}>
          {loadingSubmit ? (
            <>
              <Spinner animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
              <span>{I18n.t("actions.sending")}</span>
            </>
          ) : (
            I18n.t("actions.save")
          )}
        </Button>
      </div>
    </WorkflowRequirementStageFormContext.Provider>
  );
};

export default WorkflowRequirementStageForm;
